import uuidV4 from 'lib/string/uuidV4Utils'

export function generateCarHireCheckoutItem(
  offer: App.CarHireOffer,
  bookingDetails: {
    pickUpDate: string;
    pickUpTime: string;
    pickUpLocation?: string;
    pickUpLocationId: string;
    pickUpSearchType?: string;
    dropOffDate: string;
    dropOffTime: string;
    dropOffLocation?: string;
    dropOffLocationId: string;
    dropOffSearchType?: string;
    ageCategory: App.CarHireDriverAgeCategory;
    age?: number;
    isPickUpAtAirport: boolean;
    selectedInsuranceType?: App.CarHireInsuranceType;
    resultsTimestamp: number;
  },
): App.Checkout.CarHireItem {
  return {
    ...bookingDetails,
    itemType: 'car-hire',
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    offerId: offer.id,
    offer,
    totalPrice: offer.price,
  }
}
